import { getYear } from 'date-fns'

export const CANONICAL_HOSTNAME = 'omni.co'
export const LEGACY_HOSTNAME = 'exploreomni.com'

/** Kept in step with `healthCheckPath` in render.yaml. */
export const HEALTH_CHECK_PATH = '/api/health'

export const GA_TRACKING_ID = 'GTM-MNRVVBM'
export const SITE_TITLE = 'Omni Analytics'
export const COPYRIGHT = `© ${getYear(new Date())} Omni Analytics`

export const RUDDERSTACK_WRITE_KEY = '2XM30f94XBew2vOiaSwt3Wvo1BD'
export const RUDDERSTACK_DATAPLANE_URL =
  'https://exploreomnxjvb.dataplane.rudderstack.com'

/**
 * `sys.updatedAt` predating this is treated as no revision. An audit of the 187
 * post entries found 184 with an updatedAt after their publish date, 152 of
 * them from two bulk operations on 2026-06-10 and 2026-06-16 — median gap from
 * publish, 419 days. Without a floor, the first deploy would announce those as
 * revisions to crawlers and subscribers at once.
 */
export const REVISIONS_TRACKED_FROM = new Date('2026-08-25T00:00:00.000Z')

export const BLOG_PAGE_SIZE = 12

export const trialText = {
  cta: 'Free Trial',
  to: '/demo',
  // page stuff
  conversionId: 'free-trial',
  description: 'Get reports and dashboards you can use right now.',
  formTitle: 'Request a free trial',
  title: 'Try Omni with your data',
  formButton: 'Request Free Trial',
}
